import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { validate } from 'app/shared/elements/ess-rule';
import { Toaster } from 'app/shared/lib/toaster';
import * as FM from 'app/fm/models/essette-api';
import { FaxService } from 'app/fm/services/fax-service';
@autoinject()
export class RouteDocumentAction extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////

    @bindable
    private faxDoc!: FM.FaxDocument;

    @bindable
    private queues: FM.FaxQueue[] = [];
    @bindable
    private priorities: FM.FaxPriority[] = [];

    private targetQueue?: FM.FaxQueue;
    private targetPriority?: FM.FaxPriority;

    protected validate = validate;

    @bindable
    public returnToQueue!: () => Promise<void>;

    @bindable
    public getNextDocument!: () => Promise<void>;

    ////****************** Element References ***************************************////
    private $routeDocumentForm!: IForm;
    private $routeDocumentAction: RouteDocumentAction = this;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly faxService: FaxService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return false;
    }

    public resetForm(): void {
        this.targetPriority = undefined;
        this.targetQueue = undefined;
    }

    ////****************** Functions ************************************************////

    public async cancelAndReturn(): Promise<void> {
        this.returnToQueue();
    }

    public async submitAndGetNext(): Promise<void> {
        let success = await this.routeFax();
        if(success) {
            await this.getNextDocument();
            this.resetForm();
        }
    }

    public async submitAndReturn(): Promise<void> {
        let success = await this.routeFax();
        if(success) {
            this.returnToQueue();
        }
    }

    ////****************** Service Calls ********************************************////

    public async routeFax(): Promise<boolean> {
        if(!this.faxDoc.id) return false;

        let isSuccessful = false;
        try {
            this.state.beginSave();

            const routeData = {
                priority: { id: this.targetPriority?.id },
                queue: { id: this.targetQueue?.id }
            };

            const response = await this.faxService.routeFaxDocument(this.faxDoc.id, routeData);
            isSuccessful = response.isSuccessful;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.toaster.standard.routed('fm:faxDocument.$', isSuccessful);
            this.state.endSave();
            return isSuccessful;
        }
    }

}
